import React from 'react';
import { Document, Image, Link, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import logo from '../RendezvousOnTheRed/Assets/full_duck_left_blue.png';
import dayjs from 'dayjs';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 40,
    fontFamily: 'Helvetica',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
    alignItems: 'flex-start',
  },
  header2: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
    alignItems: 'flex-start',
  },
  logoContainer: {
    width: '35%',
    marginBottom: 15,
  },
  logo: {
    width: '100%',
    height: 'auto',
  },
  companyInfo: {
    flexDirection: 'column',
  },
  invoiceInfo: {
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  companyName: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: 'Helvetica-Bold',
    marginBottom: 4,
  },
  rendezvous: {
    fontSize: 10,
    fontStyle: 'oblique',
    fontFamily: 'Helvetica-Oblique',
    color: 'grey',
  },
  address: {
    fontSize: 10,
    marginBottom: 4,
    fontFamily: 'Helvetica',
  },
  invoiceTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    fontFamily: 'Helvetica-Bold',
    color: 'grey',
    textAlign: 'right',
  },
  invoiceDetails: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  invoiceLabel: {
    fontWeight: 'bold',
    fontFamily: 'Helvetica-Bold',
  },
  customerInfo: {
    marginBottom: 15,
    fontFamily: 'Helvetica',
  },
  toLabel: {
    fontWeight: 'bold',
    fontSize: 10,
    marginBottom: 4,
    fontFamily: 'Helvetica-Bold',
  },
  customerText: {
    fontSize: 10,
    marginBottom: 4,
    fontFamily: 'Helvetica',
  },
  table: {
    display: 'table',
    width: 'auto',
    marginBottom: 20,
    fontFamily: 'Helvetica',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#EEEEEE',
    fontWeight: 'bold',
    padding: 4,
    fontSize: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#CCCCCC',
    fontFamily: 'Helvetica-Bold',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#CCCCCC',
    fontFamily: 'Helvetica',
  },
  tableCell: {
    flex: 1,
    padding: 4,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  totalLabel: {
    fontWeight: 'bold',
    fontSize: 10,
    padding: 4,
    fontFamily: 'Helvetica-Bold',
  },
  totalValue: {
    fontSize: 10,
    padding: 4,
    textAlign: 'right',
    fontFamily: 'Helvetica',
  },
  paymentsLabel: {
    fontWeight: 'bold',
    fontSize: 10,
    marginBottom: 6,
    fontFamily: 'Helvetica-Bold',
  },
  paymentsTable: {
    display: 'table',
    width: 'auto',
    marginBottom: 20,
    fontFamily: 'Helvetica',
  },
  paymentsTableHeader: {
    flexDirection: 'row',
    backgroundColor: '#EEEEEE',
    fontWeight: 'bold',
    padding: 4,
    fontSize: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#CCCCCC',
    fontFamily: 'Helvetica-Bold',
  },
  paymentsTableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#CCCCCC',
    fontFamily: 'Helvetica',
  },
  paymentsTableCell: {
    flex: 1,
    padding: 4,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  footer: {
    fontSize: 10,
    textAlign: 'center',
    fontFamily: 'Helvetica',
  },
  footerText: {
    textAlign: 'left',
    marginBottom: 4,
    fontFamily: 'Helvetica',
  },
  thankYou: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: 15,
    fontFamily: 'Helvetica-Bold',
  },
});

const PDFDocument = ({ data = [] }) => {
  const convertValueToCurrency = (value) => {
    const numberValue = Number(value);
    if (isNaN(numberValue)) {
      return typeof value === 'number' ? '-' : value;
    }
    return numberValue.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  };

  return (
    <Document>
      {data.map((exhibitor) => (
        <Page key={exhibitor.rotr_exhibitor_id} break size='A4' style={styles.page}>
          <View style={styles.logoContainer}>
            <Image src={logo} style={styles.logo} />
          </View>

          <View style={styles.header}>
            <View style={styles.companyInfo}>
              <Text style={styles.companyName}>Sports South</Text>
              <Text style={styles.rendezvous}>Rendezvous on the Red</Text>
            </View>
            <Text style={styles.invoiceTitle}>INVOICE</Text>
          </View>

          <View style={styles.header2}>
            <View style={styles.companyInfo}>
              <Text style={styles.address}>101 Robert G. Harris Dr.</Text>
              <Text style={styles.address}>Shreveport LA, 71115</Text>
              <Text style={styles.address}>Phone: (800) 388-3845</Text>
            </View>
            <View style={styles.invoiceInfo}>
              <Text style={styles.address}>
                INVOICE NUMBER: ROTR_B{String(exhibitor.rotr_exhibitor_id).padStart(4, '0')}
              </Text>
              <Text style={styles.address}>INVOICE DATE: 02/17/2025</Text>
              <Text style={styles.address}>DUE DATE: 03/31/2025</Text>
            </View>
          </View>

          <View style={styles.customerInfo}>
            <Text style={styles.toLabel}>TO:</Text>
            <Text style={styles.customerText}>
              {exhibitor.first_name} {exhibitor.last_name}
            </Text>
            <Link src={`mailto:${exhibitor.payment_email}`} style={styles.customerText}>
              {exhibitor.payment_email}
            </Link>
            <Text style={styles.customerText}>{exhibitor.exhibitor_name}</Text>
          </View>

          <View style={styles.table}>
            <View style={styles.tableHeader}>
              <Text style={[styles.tableCell, { flex: 2, textAlign: 'left' }]}>DESCRIPTION</Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }]}>QUANTITY</Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }]}>UNIT PRICE</Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }]}>TOTAL</Text>
            </View>
            <View style={styles.tableRow}>
              <Text style={[styles.tableCell, { flex: 2, textAlign: 'left' }]}>
                ROTR Booth: {exhibitor.booth_number} ({exhibitor.booth_type})
              </Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }]}>1</Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }]}>
                {convertValueToCurrency(exhibitor.booth_price)}
              </Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }]}>
                {convertValueToCurrency(exhibitor.booth_price)}
              </Text>
            </View>
            {exhibitor.addons.map((addon) => (
              <View key={addon.addon_id} style={styles.tableRow}>
                <Text style={[styles.tableCell, { flex: 2, textAlign: 'left' }]}>
                  {addon.addon_description}
                </Text>
                <Text style={[styles.tableCell, { textAlign: 'right' }]}>
                  {addon.addon_qty_selected}
                </Text>
                <Text style={[styles.tableCell, { textAlign: 'right' }]}>
                  {convertValueToCurrency(addon.addon_price)}
                </Text>
                <Text style={[styles.tableCell, { textAlign: 'right' }]}>
                  {convertValueToCurrency(addon.addon_qty_selected * Number(addon.addon_price))}
                </Text>
              </View>
            ))}
            <View style={styles.tableRow}>
              <Text style={[styles.tableCell, { flex: 2, textAlign: 'left' }]}>-</Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }]}>-</Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }]}>-</Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }]}>-</Text>
            </View>
            <View style={styles.tableRow}>
              <Text style={[styles.tableCell, { flex: 2, textAlign: 'left' }, styles.totalLabel]}>
                TOTAL INVOICE
              </Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }]}></Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }]}></Text>
              <Text style={[styles.tableCell, { textAlign: 'right' }, styles.totalValue]}>
                {convertValueToCurrency(
                  Number(exhibitor.booth_price) +
                    exhibitor.addons.reduce(
                      (acc, addon) => acc + addon.addon_qty_selected * Number(addon.addon_price),
                      0
                    )
                )}
              </Text>
            </View>
          </View>

          <Text style={styles.paymentsLabel}>PAYMENTS</Text>
          <View style={styles.paymentsTable}>
            <View style={styles.paymentsTableHeader}>
              <Text style={[styles.paymentsTableCell, { flex: 4, textAlign: 'left' }]}>
                DESCRIPTION
              </Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'left' }]}>TYPE</Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'left' }]}>DATE</Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'right' }]}>AMOUNT</Text>
            </View>
            <View style={styles.paymentsTableRow}>
              <Text style={[styles.paymentsTableCell, { flex: 4, textAlign: 'left' }]}>
                TOTAL INVOICE
              </Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'left' }]}></Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'left' }]}></Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'right' }]}>
                {convertValueToCurrency(
                  Number(exhibitor.booth_price) +
                    exhibitor.addons.reduce(
                      (acc, addon) => acc + addon.addon_qty_selected * Number(addon.addon_price),
                      0
                    )
                )}
              </Text>
            </View>
            {exhibitor.payments.map((payment) => (
              <View key={payment.payment_id} style={styles.paymentsTableRow}>
                <Text style={[styles.paymentsTableCell, { flex: 4, textAlign: 'left' }]}>
                  {payment.payment_description}
                </Text>
                <Text style={[styles.paymentsTableCell, { textAlign: 'left' }]}>
                  {payment.payment_type}
                </Text>
                <Text style={[styles.paymentsTableCell, { textAlign: 'left' }]}>
                  {dayjs(payment.payment_date).format('MM/DD/YYYY')}
                </Text>
                <Text style={[styles.paymentsTableCell, { textAlign: 'right' }]}>
                  {convertValueToCurrency(-payment.payment_amount)}
                </Text>
              </View>
            ))}
            <View style={styles.paymentsTableRow}>
              <Text style={[styles.paymentsTableCell, { flex: 4, textAlign: 'left' }]}>-</Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'left' }]}>-</Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'left' }]}>-</Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'right' }]}>-</Text>
            </View>
            <View style={styles.paymentsTableRow}>
              <Text
                style={[
                  styles.paymentsTableCell,
                  { flex: 4, textAlign: 'left' },
                  styles.totalLabel,
                ]}
              >
                REMAINING BALANCE DUE
              </Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'left' }]}></Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'left' }]}></Text>
              <Text style={[styles.paymentsTableCell, { textAlign: 'right' }]}>
                {convertValueToCurrency(
                  Number(exhibitor.booth_price) +
                    exhibitor.addons.reduce(
                      (acc, addon) => acc + addon.addon_qty_selected * Number(addon.addon_price),
                      0
                    ) -
                    exhibitor.payments.reduce(
                      (acc, payment) => acc + Number(payment.payment_amount),
                      0
                    )
                )}
              </Text>
            </View>
          </View>

          <View style={styles.footer}>
            <Text style={styles.footerText}>
              Credit memos should be sent to{' '}
              <Link src='mailto:lindsey.scott@sportssouth.biz' style={styles.footerText}>
                lindsey.scott@sportssouth.biz
              </Link>
              .
            </Text>
            <Text style={styles.footerText}>
              If you have any questions concerning this invoice, email{' '}
              <Link src='mailto:lindsey.scott@sportssouth.biz' style={styles.footerText}>
                lindsey.scott@sportssouth.biz
              </Link>
              .
            </Text>
            <Text style={styles.thankYou}>Thank you for your business!</Text>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default PDFDocument;
